import { agent } from 'src/api/agent';
import { throwApiError } from 'src/api/utils';

import type { Directories } from '../directories/directories.store';

const SETTINGS_URLS_BY_SECTION: Record<string, { GET: string; POST: string; PATCH?: string }> = {
  palette: {
    GET: 'userSettings/palette',
    POST: 'userSettings/palette/new',
    PATCH: 'userSettings/palette',
  },
};

export class SystemSettingsApi {
  private readonly directories: Directories;

  constructor(directories: Directories) {
    this.directories = directories;
  }

  async loadSettings<T extends object = object>(settingsSection: string): Promise<T> {
    const url = SETTINGS_URLS_BY_SECTION[settingsSection]?.GET ?? '';

    try {
      const { data } = await agent.get<T>(url);

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async createSetting<T extends object = object>(settingsSection: string, setting: T): Promise<T> {
    const url = SETTINGS_URLS_BY_SECTION[settingsSection]?.POST ?? '';
    try {
      await agent.post<{ id: number }>(url, setting);
      const data = await this.loadSettings<T>(settingsSection);

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async updateSettings<T extends object = object>(section: string, updatedData: T, signal?: AbortSignal): Promise<T> {
    const url = SETTINGS_URLS_BY_SECTION[section]?.PATCH ?? '';
    try {
      await agent.patch<T>(url, updatedData, { signal });
      const data = await this.loadSettings<T>(section);

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }
}
